import { TextField, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  "& .MuiOutlinedInput-input::-webkit-input-placeholder": {
    color: theme.palette.text.primary,
    opacity: "0.5",
    fontWeight: 400,
  },
  "& .MuiOutlinedInput-input::-moz-placeholder": {
    color: theme.palette.text.primary,
    opacity: "0.5",
    fontWeight: 400,
  },
  "& .MuiOutlinedInput-input:-ms-input-placeholder": {
    color: theme.palette.text.primary,
    opacity: "0.5",
    fontWeight: 400,
  },
  "& .MuiOutlinedInput-input::placeholder": {
    color: theme.palette.text.primary,
    opacity: "0.5",
    fontWeight: 400,
  },
  "& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder": {
    color: theme.palette.text.secondary,
    opacity: "1",
  },
  "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[200],
  },
}));

export default CustomTextField;
